import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import authDialog from '@/utils/authDialog'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/index.vue')
        },
        {
          path: 'game',
          name: 'Game',
          component: () => import('@/views/game/index.vue')
        },
        {
          path: 'mini',
          name: 'Mini',
          component: () => import('@/views/game-special/index.vue')
        },
        {
          path: 'popular',
          name: 'Popular',
          component: () => import('@/views/game-special/index.vue')
        },
        {
          path: 'game-mini',
          redirect: '/mini'
        },
        {
          path: 'live',
          name: 'Live',
          component: () => import('@/views/live/index.vue')
        },

        {
          path: 'popup-dialog-toast-demo',
          name: 'PopupDialogToastDemo',
          component: () => import('@/views/PopupDialogToastDemo.vue')
        },
        {
          path: 'input-demo',
          name: 'InputDemo',
          component: () => import('@/views/InputDemo.vue')
        },
        {
          path: 'webp-demo',
          name: 'WebpDemo',
          component: () => import('@/views/WebpDemoPage.vue')
        },
        {
          path: 'promotions',
          name: 'Activity',
          component: () => import('@/views/activity/index.vue'),
          props: (route) => ({
            activeTab: route.query.tab
          })
        },
        {
          path: 'activity-detail/16/log', // 救援金活动-领取记录
          name: 'ActivityDetailLog',
          meta: { auth: true },
          component: () => import('@/views/activity-detail/loss-profit-rebate/log.vue'),
          props: (route) => ({
            id: route.query.id
          })
        },
        {
          path: 'activity-detail/:type',
          name: 'ActivityDetail',
          meta: { auth: true },
          component: () => import('@/views/activity-detail/index.vue'),
          props: (route) => ({
            type: route.params.type,
            id: route.query.id,
            title: route.query.title
          })
        },
        {
          path: 'settings',
          name: 'Settings',
          component: () => import('@/views/Settings.vue')
        },
        {
          path: 'fav',
          name: 'Favorites',
          component: () => import('@/views/fav/index.vue'),
          meta: { auth: true }
        },
        {
          path: 'agreement',
          name: 'Agreement',
          component: () => import('@/views/agreement/index.vue')
        },
        {
          path: 'share',
          name: 'Share',
          component: () => import('@/views/share/index.vue'),
          meta: { auth: true },
          redirect: '/share/rebate',
          children: [
            { path: 'rebate', name: 'Rebate', component: () => import('@/views/share/Rebate.vue') },
            { path: 'link', name: 'Link', component: () => import('@/views/share/Link.vue') },
            { path: 'member', name: 'Member', component: () => import('@/views/share/Member.vue') },
            {
              path: 'commission',
              name: 'Commission',
              component: () => import('@/views/share/Commission.vue')
            },
            {
              path: 'tutorial',
              name: 'Tutorial',
              component: () => import('@/views/share/Tutorial.vue')
            },
            { path: 'sms', name: 'Sms', component: () => import('@/views/share/Sms.vue') }
          ]
        },
        {
          path: 'share/custom',
          name: 'Custom',
          component: () => import('@/views/share/Custom.vue'),
          meta: { auth: true }
        },
        {
          path: 'provider',
          name: 'Provider',
          component: () => import('@/views/provider/index.vue')
        },
        {
          path: 'agent',
          name: 'Agent',
          component: () => import('@/views/agent/index.vue'),
          meta: { auth: false }
        },
        {
          path: 'notice',
          name: 'Notice',
          component: () => import('@/views/notice/index.vue'),
          meta: { auth: true }
        },
        {
          path: 'vip',
          name: 'Vip',
          component: () => import('@/views/vip/index.vue')
          // meta: { auth: true }
        },
        {
          path: 'about',
          name: 'About',
          component: () => import('@/views/about/index.vue')
        },
        {
          path: 'news',
          name: 'News',
          meta: { auth: true },
          component: () => import('@/views/news/index.vue')
        },
        {
          path: 'news/detail',
          name: 'NewsDetail',
          meta: { auth: true },
          component: () => import('@/views/news/detail.vue')
        },
        {
          path: 'feedback',
          name: 'Feedback',
          component: () => import('@/views/feedback/index.vue')
        },
        {
          path: '',
          component: () => import('@/layouts/AccountLayout.vue'),
          children: [
            {
              path: 'deposit',
              name: 'Deposit',
              meta: { auth: true },
              component: () => import('@/views/deposit/index.vue')
            },
            {
              path: 'withdraw/:type?',
              name: 'Withdraw',
              meta: { auth: true },
              component: () => import('@/views/withdraw/index.vue')
            },
            {
              path: 'paymentMethod/:type/add',
              name: 'PaymentMethodAdd',
              meta: { auth: true },
              component: () => import('@/views/paymentMethod/add.vue')
            },
            {
              path: 'paymentMethod/:type?',
              name: 'PaymentMethod',
              meta: { auth: true },
              component: () => import('@/views/paymentMethod/index.vue')
            },
            {
              path: 'deposit/thirdDepositPage',
              name: 'DepositThirdPage',
              meta: { auth: true },
              component: () => import('@/views/deposit/thirdDepositPage.vue')
            },
            {
              path: 'deposit/bankOfflineResult',
              name: 'DepositBankOfflineResult',
              meta: { auth: true },
              component: () => import('@/views/deposit/bankOfflineResult.vue')
            },
            {
              path: 'bet-history',
              name: 'BetHistory',
              component: () => import('@/views/bet-history/index.vue'),
              meta: { auth: true }
            },
            {
              path: 'trade-history',
              name: 'TradeHistory',
              component: () => import('@/views/trade-history/index.vue'),
              meta: { auth: true }
            },
            {
              path: 'welfare',
              name: 'Welfare',
              component: () => import('@/views/welfare/index.vue'),
              meta: { auth: true }
            },
            {
              path: 'account-security',
              meta: { auth: true },
              component: () => import('@/views/account-security/router-view.vue'),
              children: [
                {
                  path: '',
                  name: 'AccountSecurity',
                  component: () => import('@/views/account-security/index.vue')
                },
                {
                  path: 'phone-number',
                  name: 'AccountSecurityPhoneNumber',
                  component: () => import('@/views/account-security/pages/PhoneNumberPage.vue')
                },
                {
                  path: 'login-password',
                  name: 'AccountSecurityLoginPassword',
                  component: () => import('@/views/account-security/pages/LoginPasswordPage.vue')
                },
                {
                  path: 'withdraw-password',
                  name: 'AccountSecurityWithdrawPassword',
                  component: () => import('@/views/account-security/pages/WithdrawPasswordPage.vue')
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/embedded',
      name: 'EmbeddedGame',
      component: () => import('@/views/embedded/index.vue'),
      props: true
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import('@/views/NotFound.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: (to) => ({
        path: '/404',
        query: {
          from: to.fullPath
        }
      })
    }
  ]
})

// 路由守卫：检查是否需要登录
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('AUTH_TOKEN')
  const isAuthenticated = !!token

  // 检查目标路由的 meta 是否需要登录
  const requiresAuth = to.matched.some((record) => record.meta.auth)
  // 自定义活动游客可见
  const isCustomActivity = to.name === 'ActivityDetail' && to.params.type === '10'

  if (requiresAuth && !isAuthenticated && !isCustomActivity) {
    console.warn('未登录，无法访问该页面:', to.path)
    authDialog.login(() => {
      to.fullPath ? router.push(to.fullPath) : next()
    })
    next(false)
  } else {
    next()
  }
})

router.onError((error, to) => {
  console.error('路由跳转异常:', error)

  if (to.path === '/404') return

  const message = String((error as Error)?.message || '')
  const isChunkLoadError =
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /Loading chunk [\d]+ failed/i.test(message)

  if (isChunkLoadError) {
    // 刷新当前地址，处理部署后旧 chunk 缓存导致的白屏。
    window.location.href = to.fullPath
    return
  }

  router.replace({ path: '/404', query: { from: to.fullPath } })
})

export default router
